export const STYLES_PRESET_V2 = 'evStylesPresetV2'
export const CLASSIC_PRESET = 'evClassicPreset'
